var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('input',{staticClass:"form-control mb-2",attrs:{"type":"text","name":"filterTrips","placeholder":"Filter"},domProps:{"value":_vm.filterValue},on:{"input":_vm.onChange}}),_c('trip_table',{attrs:{"trips":_vm.trips}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }